import { combineReducers } from 'redux';
import { configurationReducer } from '../../components/app/app-redux';
import buyOrderEditReducer from '../../components/admin/buy-process/buy-order-edit/buy-order-edit-redux';
import { buyOrderPeopleReducer } from '../../components/admin/buy-process/people/people-redux';
import { buyOrderOrganizationsReducer } from '../../components/admin/buy-process/organizations/organizations-redux';
import { sellOrderReducer } from '../../components/admin/sell-process/sell-process-redux';
// eslint-disable-next-line max-len
import { sellOrderOrganizationsReducer } from '../../components/admin/sell-process/components/sell-process-organizations/sell-process-organizations-redux';
import { sellOrderPeopleReducer } from '../../components/admin/sell-process/components/sell-process-people/sell-process-people-redux';
import { notificationsReducer } from '../../components/notifications/notifications-redux';
import { sellOrderBanksSlice } from '../../services/sell-process/banks/reducer';

/*
 * Need to do this because RTK Query will complain of a circular
 * reference if its added here, and we need the "RootState" definition
 * for the types.
 *
 * "reducers" is used as a fake initializer here with "combineReducers"
 * just to obtain the type. The real initializer is in "store.ts".
 * */
export const reducers = {
  configuration: configurationReducer,

  buyOrderEdit: buyOrderEditReducer,
  buyOrderPeople: buyOrderPeopleReducer,
  buyOrderOrganizations: buyOrderOrganizationsReducer,

  sellOrder: sellOrderReducer,
  sellOrderOrganizations: sellOrderOrganizationsReducer,
  sellOrderPeople: sellOrderPeopleReducer,
  sellOrderBanks: sellOrderBanksSlice.reducer,

  notifications: notificationsReducer,
};

export const rootReducer = combineReducers(reducers);

export type RootState = ReturnType<typeof rootReducer>;
